import { Box, Image, Stack, Text } from "@mantine/core";
import { Button, Card } from "@onengine/component-library";
import { createFileRoute, retainSearchParams, useNavigate } from "@tanstack/react-router";
import {
  leaveRecordTenant,
  recordTenantSearchSchema,
  syncRecordTenant,
} from "@/utils/recordTenantRoute";
import styles from "./work-order-filled.module.scss";

export const Route = createFileRoute(
  "/work-orders/$workOrderId/accept-work-order/work-order-filled/",
)({
  component: WorkOrderFilled,
  validateSearch: recordTenantSearchSchema.parse,
  search: { middlewares: [retainSearchParams(["tenant"])] },
  onEnter: syncRecordTenant,
  onStay: syncRecordTenant,
  onLeave: leaveRecordTenant,
});

function WorkOrderFilled() {
  const navigate = useNavigate();
  return (
    <Box className={styles.successContainer}>
      <Stack style={{ maxWidth: 600 }} gap={"var(--spacing-x-large, 24px)"}>
        <Stack>
          <Image style={{ width: "64px" }} src={"/favicon.svg"} alt="Success" />
          <Text className={styles.successHeaderText}>This work order has been filled</Text>
        </Stack>
        <Card style={{ padding: "var(--spacing-medium, 16px)" }}>
          <Text className={styles.successDescriptionText}>
            This work order has already been claimed by another service provider.
          </Text>
          <br />
          <Text className={styles.successDescriptionText}>
            New work orders are posted regularly - check back soon for the next opportunity.
          </Text>
        </Card>
        <Button
          type="button"
          variant="primary"
          style={{ width: "fit-content", marginLeft: "auto" }}
          onClick={() =>
            navigate({
              to: "/work-orders",
              search: {
                tab: "NewWorkOrders",
              },
            })
          }
        >
          Back to New Work Orders
        </Button>
      </Stack>
    </Box>
  );
}
